import { render } from "./transaction-list.vue?vue&type=template&id=3cb9a60e"
import script from "./transaction-list.vue?vue&type=script&lang=js"
export * from "./transaction-list.vue?vue&type=script&lang=js"

import exportComponent from "/builds/commerce/central/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__